/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryMethodCreateRequest } from '../../models/delivery-method-create-request';
import { DeliveryMethodCreateResponse } from '../../models/delivery-method-create-response';

export interface CreateDeliveryMethod$Params {
      body: DeliveryMethodCreateRequest
}

export function createDeliveryMethod(http: HttpClient, rootUrl: string, params: CreateDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryMethodCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createDeliveryMethod.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryMethodCreateResponse>;
    })
  );
}

createDeliveryMethod.PATH = '/delivery/methods';
